<template>
  <ul class="item">
    <li class="item__list"
      v-for="(item, index) in movieList"
      :key="index"
    >
      <a :href="linkCreater(item, index)" class="item__list__link">
        <span class="image-wrap">
          <img v-if="!!item.pack_image"
            :src="srcCreater(item)"
            @load="onImgLoad"
            class="item__list__link__image"
          >
        </span>
        <div class="item__list__link__detail" :class="noimageClass(item)">
          <p class="item__list__link__detail__title">{{item.item_name}}</p>
          <p class="item__list__link__detail__description">{{item.easy_explanation}}</p>
          <ul class="item__list__link__detail__tag">
            <li class="item__list__link__detail__tag__list">占いビデオレター</li>
            <li class="item__list__link__detail__tag__list" v-if="item.planning_id === 1">結婚</li>
            <li class="item__list__link__detail__tag__list" v-if="item.planning_id === 4">恋愛</li>
          </ul>
          <div class="item__list__link__detail__evaluatewrap">
            <div class="item__list__link__detail__evaluatewrap__inner">
              <p class="item__list__link__detail__stars" v-if="showStars">
                <evaluate-stars :target-id="getEvaluationData(item.item_name)" />
              </p>
              <p class="item__list__link__detail__price">
                ¥{{item.price_taxin}}
                <span>(税込)</span>
              </p>
            </div>
          </div>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'modern-list',
  data() {
    return {
      movieList: [],
      styleObject: {
        display: 'none'
      },
      showStars: false
    };
  },
  mounted() {
    const planning_id = [4, 1];
    axios
      .post('/api/items/getplan', { plan_id: planning_id })
      .then(res => {
        this.movieList = res.data.data_list;
      })
      .then(() => {
        return this.temporaryAdd();
      });
  },
  methods: {
    temporaryAdd() {
      const addList = [
        {
          easy_explanation: '有名占い師お墨付きの実力を備えた、占い芸人があなたのことを占います！',
          item_name: '占い芸人ビデオレター',
          pack_image: '/static/img/top/videoletter_custom_uragei.png',
          planning_id: '',
          price_taxin: '990'
        },
        {
          easy_explanation: '人気占い師にお得に占ってもらうチャンス！気軽に相談できちゃいます。',
          item_name: 'なんでもお悩み相談（占い師おまかせ）',
          pack_image: '/static/img/top/videoletter_custom_2.png',
          planning_id: 2,
          price_taxin: '990'
        },
        {
          easy_explanation: '話を聞いてみたい占い師がいるならこちらから！',
          item_name: 'なんでもお悩み相談（占い師を指名）',
          pack_image: '/static/img/top/videoletter_custom_shimei.png',
          planning_id: '',
          price_taxin: '1,480'
        }
      ];
      addList.map(val => {
        this.movieList.push(val);
      });
    },
    getEvaluationData(identifier) {
      const compareList = [
        { word: 'ネクストカレシ予報', targetId: 'next' },
        { word: '結婚タイミング診断', targetId: 'marriage' },
        { word: '占い芸人ビデオレター', targetId: 'uragei' },
        { word: 'なんでもお悩み相談（占い師おまかせ）', targetId: 'omakase' },
        { word: 'なんでもお悩み相談（占い師を指名）', targetId: 'firstcome' }
      ]
      for(let item of compareList){
        if(item.word === identifier) return item.targetId
      }
    },
    linkCreater(item, index) {
      if (item.item_name === '占い芸人ビデオレター') return `/lp/uragei?top_vid=${index + 1}`;
      if (item.item_name === 'なんでもお悩み相談（占い師を指名）') return `/movie/firstcome?top_vid=${index + 1}`;
      else return `/movie/custom/${item.planning_id}?top_vid=${index + 1}`;
    },
    srcCreater(item) {
      if (item.planning_id === '') return item.pack_image;
      return `/static/img/top/videoletter_custom_${item.planning_id}.jpg`;
    },
    noimageClass(item) {
      if (!item.pack_image) return 'noimg';
    },
    clickOpen() {
      const listitem = this.$refs.listItem;
      Object.keys(listitem).forEach(function(elm) {
        listitem[elm].style.display = 'block';
      });
      this.$refs.btnshowmoreMovie.style.display = 'none';
    },
    onImgLoad() {
      this.showStars = true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables/colors.scss';
@import '../../../sass/functions/breakpoint.scss';

.item {
  margin: 0;
  padding: 0;
  list-style: none;
  &__list {
    position: relative;
    &:nth-of-type(n + 2) {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: calc(100% - 32px);
        height: 1px;
        background: $gray-10;
        transform: translate(-50%, 0);
      }
    }
    &__link {
      position: relative;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 12px 12px 12px;
      text-decoration: none;
      @media screen and (min-width: 375px) {
        padding: 12px;
      }
      .image-wrap {
        display: block;
        width: 105px;
        position: relative;
        &::after {
          content: '';
          width: 20px;
          height: 20px;
          display: block;
          position: absolute;
          top: 8px;
          right: 8px;
          background: url('/static/img/ic-movie-contents.svg') no-repeat center center;
          background-size: 100%;
        }
        @media screen and (min-width: 375px) {
          width: 144px;
          &::after {
            width: 24px;
            height: 24px;
          }
        }
      }
      &__image {
        display: block;
        width: 105px;
        border-radius: 6px;
        @media screen and (min-width: 375px) {

          width: 144px;
        }
      }
      &__detail {
        width: calc(100% - 116px);
        position: relative;
        @media screen and (min-width: 375px) {
          position: static;
          padding-top: 8px;
          width: calc(100% - 156px);
        }
        &__title {
          line-height: 1.23;
          font-size: 13px;
          font-weight: bold;
        }
        &__description {
          line-height: 1.25;
          margin-top: 4px;
          font-size: 12px;
          color: $text-sub;
        }
        &__tag {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin: 4px 0 0;
          padding: 0;
          list-style: none;
          &__list {
            min-width: 86px;
            line-height: 16px;
            margin: 0 4px 4px 0;
            padding: 0 6px;
            font-size: 10px;
            text-align: center;
            border: 1px solid black;
            &:last-child {
              margin-right: 0;
            }
            @include breakpoint(mobileonly) {
              min-width: auto;
            }
          }
        }
        &__evaluatewrap {
          width: 100%;
          position: relative;
          &__inner {
            width: 100%;
            position: relative;
          }
          @media screen and (min-width: 375px) {
            position: absolute;
            bottom: 14px;
            width: calc(100% - 168px);
          }
        }
        &__stars {
          display: inline-block;
          vertical-align: bottom;
          line-height: 1;
          @media screen and (min-width: 375px) {
            margin-top: 0;
          }

          /deep/ .evaluate-stars-base {
            font-size: 12px;
            line-height: 1;
            @media screen and (min-width: 375px) {
              font-size: 14px;
            }
            @media screen and (min-width: 768px) {
              font-size: 16px;
            }
          }
        }
        &__price {
          display: inline-block;
          position: absolute;
          bottom: 1px;
          right: 0;
          font-size: 13px;
          font-weight: bold;
          color: $brand-2;
          line-height: 1;
          span {
            font-size: 10px;
            margin-left: -0.2em;
          }
          @media screen and (min-width: 375px) {
            right: 16px;
          }
          @media screen and (min-width: 768px) {
            font-size: 16px;
            right: 16px;
            span {
              font-size: 12px;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}

.noimg {
  width: 100%;
  min-height: 109px;
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ModernList.vue